"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTimed;
function createTimed(duration) {
  return function Timed(xParam, vParam, secPerStep, elapsed) {
    if (elapsed > duration) {
      return [1, 0, true];
    }
    return [elapsed / duration, 1 / duration, false];
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/buttery/lib/steppers/createTimed.js
// module id = 172
// module chunks = 0